import { render, staticRenderFns } from "./BarraHabilidades.vue?vue&type=template&id=fd6c712e&scoped=true&lang=pug"
import script from "./BarraHabilidades.vue?vue&type=script&lang=js"
export * from "./BarraHabilidades.vue?vue&type=script&lang=js"
import style0 from "./BarraHabilidades.vue?vue&type=style&index=0&id=fd6c712e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6c712e",
  null
  
)

export default component.exports